import React, { useEffect, useState } from "react";
import TopNavbar from "../../components/TopNavbar/TopNavbar";
import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/footer/footer";
import SuccessStoriesCard from "../../components/SuccessStoriescard/SuccessStoriescard";
import SuccessStoriesImg from "../../asset/images/successstories.png"
import axios from "axios";

const SuccessStories = () => {
  // const stories = [
  //   {
  //     id: 1,
  //     title: "Arunkumar & Aruna",
  //     description: "coimbatore & chennai",
  //     date: "11 Jul 2025",
  //     text: "I met my perfect match through kovaikongunadumatrimony.com.",
  //     image: SuccessStoriesImg,
  //   },
  //   {
  //     id: 2,
  //     title: "Arunkumar & Aruna",
  //     description: "coimbatore & chennai",
  //     date: "11 Jul 2025",
  //     text: "I met my perfect match through kovaikongunadumatrimony.com.",
  //     image: SuccessStoriesImg,
  //   },
  //   {
  //     id: 3,
  //     title: "Arunkumar & Aruna",
  //     description: "coimbatore & chennai",
  //     date: "11 Jul 2025",
  //     text: "I met my perfect match through kovaikongunadumatrimony.com.",
  //     image: SuccessStoriesImg,
  //   },
  //   {
  //     id: 4,
  //     title: "Arunkumar & Aruna",
  //     description: "coimbatore & chennai",
  //     date: "11 Jul 2025",
  //     text: "I met my perfect match through kovaikongunadumatrimony.com.",
  //     image: SuccessStoriesImg,
  //   },
  //   {
  //     id: 5,
  //     title: "Arunkumar & Aruna",
  //     description: "coimbatore & chennai",
  //     date: "11 Jul 2025",
  //     text: "I met my perfect match through kovaikongunadumatrimony.com.",
  //     image: SuccessStoriesImg,
  //   },
  //   {
  //     id: 6,
  //     title: "Arunkumar & Aruna",
  //     description: "coimbatore & chennai",
  //     date: "11 Jul 2025",
  //     text: "I met my perfect match through kovaikongunadumatrimony.com.",
  //     image: SuccessStoriesImg,
  //   },
  // ];
  const [stories, setStories] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const visibleStories = showAll ? stories : stories.slice(0, 4);
  useEffect(() => {
    axios.get('https://kovaikongunadumatrimony.com/kkm_backend/public/api/success-stories').then(response => {
      if (response.data.status == true) {
        setStories(response.data.data);
      }
    })
  }, [])

  return (
    <>
      <TopNavbar />
      <Navbar />

      <div className="container mb-5 mt-2">
        <div className="row">
          <h2 className="selectpackage_heading my-4">Success Stories</h2>
          <div className="row mx-0 px-0">
            {visibleStories.map((story) => (
              <div className="col-md-6 mb-4" key={story.id}>
                <SuccessStoriesCard
                  title={story.male_name.toUpperCase() + " ~ " + story.female_name.toUpperCase()}

                  date={story.marriage_date}
                  image={story.marriage_photo}
                  text={story.male_place + "~" + story.female_place}
                />
              </div>
            ))}
          </div>

          <div className="text-center">
            <button
              className="success-view-btn"
              onClick={() => setShowAll(!showAll)}
            >
              {showAll ? "View Less" : "View More Success Stories"}
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default SuccessStories;
